import * as React from 'react'
import * as Yup from 'yup'
import { Paper, Grid, TextField, Button, Typography } from '@mui/material'
import PageTitle from '../../components/title/PageTitle'
import { useForm } from 'react-hook-form'
import { yupResolver } from '@hookform/resolvers/yup'
import { useState, useEffect } from 'react'
import AxiosClient from '../../utils/axios'
import LoadingBar from '../../components/loading/LoadingBar'
import ErrorMessage from '../../utils/errorMessage'
import HttpErrorNotification from '../../components/notifications/HttpErrorNotification'
import Breadcrumb from '../../components/breadcrumb/Breadcrumb'
import Checkbox from '@mui/material/Checkbox'
import FormControlLabel from '@mui/material/FormControlLabel'

export default function Settings() {
  const [sendRequest, setSendRequest] = useState(false)
  const [alert, setAlert] = useState({ state: false, message: '' })
  const [settingsId, setSettingsId] = useState('')

  const [cashPaymentMethod] = useState(true)
  const [clickPaymentMethod, setClickPaymentMethod] = useState(false)
  const [paymePaymentMethod, setPaymePaymentMethod] = useState(false)
  const [uzumPaymentMethod, setUzumPaymentMethod] = useState(false)

  const setClick = (event) => setClickPaymentMethod(event.target.checked)

  const setPayme = (event) => setPaymePaymentMethod(event.target.checked)
  const setUzum = (event) => setUzumPaymentMethod(event.target.checked)

  const validationSchema = Yup.object().shape({
    delayDays: Yup.number()
      .min(0, "Kamida 0 bo'lish kerak")
      .integer()
      .required('Buyurtma berish kunini yozing'),
  })
  const {
    register,
    handleSubmit,
    formState: { errors },
    setValue,
  } = useForm({
    resolver: yupResolver(validationSchema),
  })

  const onSubmit = async ({ delayDays }) => {
    try {
      const paymentMethods = ['CASH']
      if (clickPaymentMethod) {
        paymentMethods.push('CLICK')
      }
      if (paymePaymentMethod) {
        paymentMethods.push('PAYME')
      }
      if (uzumPaymentMethod) {
        paymentMethods.push('UZUM')
      }

      await AxiosClient.put(`/settings/${settingsId}`, {
        delayDays,
        paymentMethods,
      })
      window.location.reload()
    } catch (error) {
      const message = ErrorMessage(error)
      setAlert({
        state: true,
        message,
      })
      setSendRequest(false)
    }
  }

  const fetch = async () => {
    const result = await AxiosClient.get('/settings')
    return result.data
  }

  useEffect(() => {
    setSendRequest(true)
    fetch()
      .then(
        (data) => {
          setValue('delayDays', data.delay_days)
          setSettingsId(data._id)
          if (data.paymentMethods.includes('CLICK')) {
            setClickPaymentMethod(true)
          }
          if (data.paymentMethods.includes('PAYME')) {
            setPaymePaymentMethod(true)
          }
          if (data.paymentMethods.includes('UZUM')) {
            setUzumPaymentMethod(true)
          }
        },
        (error) => {
          const message = ErrorMessage(error)
          setAlert({
            state: true,
            message,
          })
        },
      )
      .then(() => setSendRequest(false))
  }, [])

  return (
    <Paper sx={{ p: 1 }}>
      <Grid container spacing={1}>
        <Grid item xs={12}>
          <PageTitle title="Sozlama" />
        </Grid>
        <Grid item xs={12}>
          <TextField
            required
            id="delayDays"
            name="delayDays"
            label="Buyurtma berish kuni"
            {...register('delayDays')}
            type="number"
            error={errors.delayDays ? true : false}
            InputLabelProps={{ shrink: true }}
          />
          <Typography variant="inherit" color="textSecondary">
            {errors.delayDays?.message}
          </Typography>
        </Grid>
        <Grid item xs={12}>
          <FormControlLabel
            control={
              <Checkbox checked={cashPaymentMethod} disabled color="primary" />
            }
            label="Yetkazib berilganda"
          />
          <br />
          <FormControlLabel
            control={<Checkbox checked={clickPaymentMethod} color="primary" />}
            label="Click"
            onChange={setClick}
          />
          <br />
          <FormControlLabel
            control={<Checkbox checked={paymePaymentMethod} color="primary" />}
            label="Payme"
            onChange={setPayme}
          />
          <br />
          <FormControlLabel
            control={<Checkbox checked={uzumPaymentMethod} color="primary" />}
            label="Uzum"
            onChange={setUzum}
          />
        </Grid>

        <Grid item xs={12}>
          <Button
            variant="contained"
            color="primary"
            onClick={handleSubmit(onSubmit)}
          >
            Saqlash
          </Button>
        </Grid>
        <Grid item xs={12}>
          {alert.state ? (
            <HttpErrorNotification message={alert.message} />
          ) : (
            <></>
          )}
        </Grid>

        {sendRequest ? <LoadingBar /> : <></>}
        <Breadcrumb />
      </Grid>
    </Paper>
  )
}
